export default function About() {
  return (
    <section id="sobre" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-block mb-4">
              <span className="text-teal-600 font-semibold text-sm uppercase tracking-wider">Quem Somos</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Parceiros Estratégicos
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              A Consultadoria de Serviços em Saúde é uma empresa de consultadoria e prestação de serviços na área da saúde. Fundámos esta empresa com o objetivo claro de sermos parceiros estratégicos das organizações e profissionais com quem trabalhamos.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              A nossa missão é contribuir para a existência de melhores cuidados de saúde acessíveis à população, apoiando clínicas, laboratórios, consultórios e profissionais de saúde na criação, legalização e gestão eficiente das suas unidades de saúde.
            </p>
            <div className="mt-8 flex items-center gap-6">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center">
                  <i className="ri-heart-pulse-line text-teal-600 text-xl"></i>
                </div>
                <div>
                  <p className="text-2xl font-bold text-gray-900">100+</p>
                  <p className="text-sm text-gray-600">Projetos Realizados</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center">
                  <i className="ri-team-line text-teal-600 text-xl"></i>
                </div>
                <div>
                  <p className="text-2xl font-bold text-gray-900">50+</p>
                  <p className="text-sm text-gray-600">Clientes Satisfeitos</p>
                </div>
              </div>
            </div>
          </div>
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/b8373eda6202d1efb3e984ca5b573902.jpg"
                alt="Equipa de Consultoria"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-teal-600 text-white p-8 rounded-2xl shadow-xl max-w-xs">
              <p className="text-sm font-semibold mb-2">Inteligência Artificial</p>
              <p className="text-xs leading-relaxed">
                Utilizamos tecnologia de IA para otimizar processos e garantir eficiência máxima nos nossos serviços
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}